/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entryfree1Inputs */

const en_entryfree1 = /** @type {(inputs: Entryfree1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free entry`)
};

const de_entryfree1 = /** @type {(inputs: Entryfree1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freier Eintritt`)
};

/**
* | output |
* | --- |
* | "Free entry" |
*
* @param {Entryfree1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entryfree1 = /** @type {((inputs?: Entryfree1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entryfree1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entryfree1(inputs)
	return de_entryfree1(inputs)
});
export { entryfree1 as "entryFree" }